import React from "react";
import { observer } from "mobx-react-lite";
import { NotificationStore } from "./NotificationStore";
import { Toaster } from "components/ui/toaster";

export const NotificationStoreProvider = observer(
  ({ children }: React.PropsWithChildren) => {
    const notificationStore = React.useMemo(() => {
      return new NotificationStore();
    }, []);

    return (
      <NotificationStoreContext.Provider value={notificationStore}>
        {children}

        <Toaster />
      </NotificationStoreContext.Provider>
    );
  },
);

const NotificationStoreContext = React.createContext<NotificationStore | null>(
  null,
);

export function useNotificationStore(): NotificationStore {
  const store = React.useContext(NotificationStoreContext);
  if (!store) {
    throw new Error(
      "useNotificationStore must be used within NotificationStoreProvider",
    );
  }
  return store;
}
